export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }
      document.body.classList.add('page-loading')
      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      document.body.classList.remove('page-loading')
      return Promise.resolve(response)
    },
    (error: any) => {
      document.body.classList.remove('page-loading')      
     
      if (error?.response?.status === 404) {
        window.location.href = "/error/404";
        
      }
      return Promise.reject(error)
    }
  );
}
